import pluralize from 'pluralize'

export default {
    props: {
        route: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            entity: null,
            dataRetrieved: null,
        }
    },
    watch: {
        route: {
            immediate: true,
            handler: function() {
                if(this.dataRetrieved != this.route) {
                    this.dataRetrieved = this.route
                    this.retrieve();
                }
            }
        }
    },
    methods: {
        /**
         * Retrieves the resource
         * @return {[type]}
         */
        async retrieve() {
            this.$emit('onRetrieve');

            const { data } = await window.axios.get(this.route);
            this.$emit('afterRetrieve', data);
        },
    }
}